import { render, staticRenderFns } from "./VploadVideo.vue?vue&type=template&id=6c134d25&scoped=true"
import script from "./VploadVideo.vue?vue&type=script&lang=js"
export * from "./VploadVideo.vue?vue&type=script&lang=js"
import style0 from "./VploadVideo.vue?vue&type=style&index=0&id=6c134d25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c134d25",
  null
  
)

export default component.exports